/**
 * @desc 查询省份列表
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(): Promise<BaseResponse<defs.ResultBean<Array<defs.Area>>>> {
  return fetch({
    url: config.API_HOST + '/dict/findProvinceList',
    data: undefined,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
